import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import DatePicker from "src/components/DatePicker";

const DeliveryDateTo = () => {
  const { control } = useFormContext();
  const { t } = useTranslation("orders");

  return (
    <Controller
      render={({ ref, ...props }) => (
        <DatePicker
          endDate
          label={t("list_filter.delivery_date_to_label")}
          fullWidth
          {...props}
          inputRef={ref}
        />
      )}
      defaultValue=""
      name="deliveryDateTo"
      control={control}
    />
  );
};

export default DeliveryDateTo;
